import { Outlet, useLocation } from 'react-router-dom';
import Navigation from '../navigation/Navigation';
import Footer from '../footer/Footer';
import './Layout.scss';

const Layout = () => {
  const location = useLocation();

  // Check if we're on home page (video + portfolio sections)
  const isHomePage = location.pathname === '/' || location.pathname === '/portfolio';

  return (
    <div className="app">
      <Navigation />
      <main className="app__main">
        <Outlet />
      </main>
      {/* Only show Footer for non-home pages */}
      {!isHomePage && <Footer />}
    </div>
  );
};

export default Layout;
